import * as React from 'react'
import moment from 'moment'
import type { Moment } from 'moment'

import { ActivityModel, ViolationModel } from 'app/models'
import {
  withLocalizeProps,
  type LocalizeProps,
} from '@/modules/shared/context/localize/LocalizeContext'
import { CardInsertModel } from 'app/models/cardInsertModel'
import { PlaceModel } from 'app/models/placeModel'
import { DayActivityModel } from 'app/models/dayActivityModel'
import { DailyRestEventModel } from 'app/models/dailyRestEventModel'
import { DailyPartialRegularRestEventModel } from 'app/models/dailyPartialRegularRestModel'
import { WeeklyRestEventModel } from 'app/models/weeklyRestModel'
import { WeeklyReducedRestEventModel } from 'app/models/weeklyRegularRestModel'
import { BreakModel } from 'app/models/breakModel'
import { WeekRecompenseModel } from 'app/models/weekRecompenseModel'
import { PartialBreakModel } from 'app/models/partialBreakModel'
import { OutOfScopeModel } from 'app/models/outOfScopeModel'
import { TimelineWeekly } from '../../../components_new/TimelineWeekly'
import { SCENE_HEIGHT } from '../../../components_new/utils/layout'

type Props = {
  startTime: Moment
  activities: ReadonlyArray<ActivityModel>
  cardInserts: ReadonlyArray<CardInsertModel>
  places: ReadonlyArray<PlaceModel>
  dayActivities: ReadonlyArray<DayActivityModel>
  violations: ReadonlyArray<ViolationModel>
  dailyRests: ReadonlyArray<DailyRestEventModel>
  dailyPartialRegularRests: ReadonlyArray<DailyPartialRegularRestEventModel>
  weeklyRests: ReadonlyArray<WeeklyRestEventModel>
  weeklyReducedRests: ReadonlyArray<WeeklyReducedRestEventModel>
  breaks: ReadonlyArray<BreakModel>
  partialBreaks: ReadonlyArray<PartialBreakModel>
  weekRecompenses: ReadonlyArray<WeekRecompenseModel>
  outOfScopes: ReadonlyArray<OutOfScopeModel>
  onSelected?: (date) => void
  onDaySelected?: (date: Moment) => void
  days?: number
  width: number
  height: number
  backgroundColor?: string
  currentDate?: any
}

type State = {}

class MonthlyActivityChart extends React.Component<
  Props & LocalizeProps,
  State
> {
  constructor(props: Props & LocalizeProps) {
    super(props)
  }

  render() {
    const {
      startTime,
      activities,
      places,
      breaks,
      weeklyRests,
      weeklyReducedRests,
      weekRecompenses,
      currentDate,
    } = this.props

    const calculatedCurrentDate = currentDate
      ? moment(currentDate, 'YYYY-MM')
          .endOf('month')
          .add(3, 'weeks')
          .format('YYYY-MM-DD')
      : moment().endOf('month').add(3, 'weeks').format('YYYY-MM-DD')

    const days = this.props.days ?? 14
    const windowStart = moment(startTime)
    const windowEnd = windowStart.clone().add(days, 'days')

    const overlapsWindow = (start: any, end: any) =>
      moment(end ?? start).isAfter(windowStart) &&
      moment(start).isBefore(windowEnd)

    const inWindow = (time: any) => {
      const t = moment(time)
      return t.isSameOrAfter(windowStart) && t.isBefore(windowEnd)
    }

    const windowActivities = (activities ?? []).filter((a: any) =>
      overlapsWindow(a.startTime, a.endTime),
    )
    const windowBreaks = (breaks ?? []).filter((b: any) =>
      overlapsWindow(b.startTime, b.endTime),
    )
    const windowPlaces = (places ?? []).filter((p: any) =>
      inWindow(p.startTime),
    )

    const restWindowStart = windowStart.clone().add(-7, 'days')
    const restWindowEnd = windowEnd.clone().add(7, 'days')
    const overlapsRestWindow = (start: any, end: any) =>
      moment(end ?? start).isAfter(restWindowStart) &&
      moment(start).isBefore(restWindowEnd)

    const windowWeeklyRests = (weeklyRests ?? []).filter((r: any) =>
      overlapsRestWindow(r.startTime, r.endTime),
    )
    const windowWeeklyReducedRests = (weeklyReducedRests ?? []).filter(
      (r: any) => overlapsRestWindow(r.startTime, r.endTime),
    )
    const windowWeekRecompenses = (weekRecompenses ?? []).filter((r: any) =>
      overlapsRestWindow(r.startTime, r.realRestEndTime ?? r.endTime),
    )

    return (

          <TimelineWeekly
            translate={this.props.translate}
            width={this.props.width}
            height={SCENE_HEIGHT}
            startTime={startTime}
            days={days}
            extraCurrentDate={calculatedCurrentDate}
            activities={windowActivities as ActivityModel[]}
            places={windowPlaces as PlaceModel[]}
            breaks={windowBreaks as BreakModel[]}
            weeklyRests={windowWeeklyRests as WeeklyRestEventModel[]}
            weeklyReducedRests={
              windowWeeklyReducedRests as WeeklyReducedRestEventModel[]
            }
            weekRecompenses={windowWeekRecompenses as WeekRecompenseModel[]}
            showRests
            showRestParts
            onDaySelected={this.props.onDaySelected}
          />
    )
  }
}

export default withLocalizeProps(MonthlyActivityChart)
